<script setup lang="ts">
/**
 * CaGlassBar — SATU-SATUNYA pemilik efek kaca (`.ca-kaca`) di tema v3.
 *
 * Aturan yang tidak boleh dilanggar: chrome boleh kaca, konten TIDAK PERNAH.
 * Maksimal dua instans hidup di satu layar (header + bilah CTA bawah), keduanya
 * tinggi tetap dan kecil. `backdrop-filter` pada elemen besar atau elemen yang
 * ikut menggulir adalah penyebab paling umum frame drop di GPU Mali/Adreno
 * kelas bawah — dan itu persis perangkat mayoritas pengguna kita.
 */
const props = withDefaults(
  defineProps<{
    /** `atas` = header sticky, `bawah` = bilah CTA yang menempel di dasar layar. */
    posisi?: 'atas' | 'bawah'
  }>(),
  { posisi: 'atas' }
)

// Bilah bawah menutupi bagian paling akhir halaman. Halaman yang memakainya
// memberi padding pada kontennya sendiri, tetapi footer ada di LAYOUT, di luar
// jangkauan halaman — sehingga baris terakhir footer (nama badan usaha,
// catatan batas berkas) tertutup bilah saat digulir sampai habis. Penanda di
// <html> membiarkan main.css memberi ruang pada footer, hanya selama bilah ini
// terpasang.
if (props.posisi === 'bawah') {
  useHead({ htmlAttrs: { class: 'ada-bilah-bawah' } })
}
</script>

<template>
  <div
    class="ca-kaca z-40"
    :class="
      posisi === 'atas'
        ? 'sticky top-0 border-b border-line'
        : 'fixed inset-x-0 bottom-0 border-t border-line shadow-sheet'
    "
    :style="posisi === 'bawah' ? { paddingBottom: 'env(safe-area-inset-bottom)' } : undefined"
  >
    <slot />
  </div>
</template>
